import React, { Component } from 'react'
import PT from 'prop-types'
import InfiniteScroll from 'react-infinite-scroller'
import { loadMorePosts } from '../../actions'
import withWindowSize from '../../hoc/withWindowSize'
import PostsDesktop from './PostsDesktop'
import PostsMobile from './PostsMobile'
import './PostContainer.css'
import { getHasMorePosts } from './helpers'
import { filterInvalidImages } from '../../helpers'

class PostsContainer extends Component {
  state = {
    hasMore: true,
    posts: [],
  }

  handleLoadMore = () => {
    const start = this.state.posts.length
    const is89 = window.location.pathname.startsWith('/89')
    loadMorePosts(start, this.appendPosts, is89)
  }

  appendPosts = (posts) => {
    const filtered = posts.map(post => ({
      ...post,
      images: filterInvalidImages(post.images),
    }))

    setTimeout(() => {
      const hasMore = getHasMorePosts(filtered.length, this.state.posts.length)
      this.setState({
        hasMore,
      })
    }, 500)

    this.setState({
      hasMore: false,
      posts: [
        ...this.state.posts,
        ...filtered,
      ],
    })
  }

  render() {
    const { isMobile } = this.props
    const { posts } = this.state

    return (
      <InfiniteScroll
        loadMore={this.handleLoadMore}
        hasMore={this.state.hasMore}
        loader={<div key="loader-key" className="loader">Chvíľku strpenia poprosím...</div>}
      >
        {isMobile && (
          <PostsMobile posts={posts} />
        )}

        {!isMobile && (
          <PostsDesktop posts={posts} />
        )}

      </InfiniteScroll>
    )
  }
}

PostsContainer.propTypes = {
  isMobile: PT.bool.isRequired,
}

export default withWindowSize(PostsContainer)



// WEBPACK FOOTER //
// ./src/components/Post/PostsContainer.js